import { Navigate } from 'react-router-dom';
import { useOrg } from '../../components/OrgContext';
import ReportsAgent from '../../pages/ReportsAgent';
import { homeKindFor } from '../company';
import ReportsHubView from './ReportsHubView';
import CommissionsView from './CommissionsView';
import ForecastView from './ForecastView';
import DiscrepanciesView from './DiscrepanciesView';
import SuppliersView from './SuppliersView';
import SupplierView from './SupplierView';
import CustomersView from './CustomersView';
import CustomerView from './CustomerView';
import ArchiveView from './ArchiveView';
import StatementUploadView from './StatementUploadView';
import StatementResultView from './StatementResultView';

// What /reports and its screens show (redesign step 4; dev website only, App.tsx calls this only when the release switch is on):
//   - a pure agent (the same rule as the agent Home and Cases) gets the new Reports screens;
//   - everyone else keeps today's Reports pages, unchanged (the `legacy` element), or, for a screen that exists only in the new design, goes back to /reports.
const SCREENS = {
  hub: ReportsHubView, commissions: CommissionsView, forecast: ForecastView, discrepancies: DiscrepanciesView,
  suppliers: SuppliersView, supplier: SupplierView, customers: CustomersView, customer: CustomerView, archive: ArchiveView,
  'statement-upload': StatementUploadView, 'statement-result': StatementResultView,
};

export default function ReportsEntry({ screen, legacy }) {
  const { capabilities } = useOrg();
  if (homeKindFor(capabilities) !== 'agent') return legacy || <Navigate to="/reports" replace />;
  const View = SCREENS[screen];
  return View ? <ReportsAgent><View /></ReportsAgent> : <Navigate to="/reports" replace />;
}
